import { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import { CbPlayerCard } from './CbPlayerCard';
export interface CbPlayerCardSkeletonProps {}
export const CbPlayerCardSkeleton: FC<CbPlayerCardSkeletonProps> = () => {
  return <Skeleton backgroundColor="cloud.400" borderRadius={24} boxShadow="standardCard" data-sentry-element="Skeleton" data-sentry-component="CbPlayerCardSkeleton" data-sentry-source-file="CbPlayerCardSkeleton.tsx">
      <CbPlayerCard name="Chaz" id="12" description="Cool Guy with a cool job." handleGiveRecognition={() => {}} handleGiveTokens={() => {}} isSelected={false} data-sentry-element="CbPlayerCard" data-sentry-source-file="CbPlayerCardSkeleton.tsx" />
    </Skeleton>;
};